<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            v-if="dialog"
            persistent
            max-width="750px">
            <v-form
                lazy-validation
                ref="form"
                v-model="valid">
                <v-card>
                    <v-card-title>
                        <span class="headline">
                            {{header}}
                        </span>
                    </v-card-title>
                    <v-card-text>
                        <input type="hidden" name="form.typeMessage" :value="typeMessage">
                        <v-container>
                            <v-row>
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="6">
                                    <v-text-field
                                    v-model="form.topic"
                                    :rules="inputRules"
                                    :error-messages="errors.topic"
                                    :label="$vuetify.lang.t('$vuetify.messageModal.topic')"
                                    autofocus
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="6">
                                    <v-autocomplete
                                        v-if="typeMessage === 'IND'"
                                        v-model="form.employeeId"
                                        :label="$vuetify.lang.t('$vuetify.messageModal.employeeNo')"
                                        :items="employeeNoList"
                                        item-text="employee_no"
                                        item-value="id"
                                        :rules="autocompleteRules"
                                        :error-messages="errors.employeeId"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="6">
                                    <v-menu
                                        v-model="startDatePickerShow"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="startDateFormatted"
                                                :label="$vuetify.lang.t('$vuetify.messageModal.startDate')"
                                                prepend-inner-icon="mdi-calendar"
                                                :error-messages="errors.startDate"
                                                @click:prepend-inner="startDatePickerShow = true"
                                                readonly
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            :locale="localeLang"
                                            v-model="form.startDate"
                                            :rules="inputRules"
                                            :min="statusDateConfig.min"
                                            @change="saveStatusStart"
                                            @input="startDatePickerShow = false"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="6">
                                    <v-menu
                                        v-model="endDatePickerShow"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="endDateFormatted"
                                                :label="$vuetify.lang.t('$vuetify.messageModal.endDate')"
                                                prepend-inner-icon="mdi-calendar"
                                                :error-messages="errors.endDate"
                                                @click:prepend-inner="endDatePickerShow = true"
                                                readonly
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            :locale="localeLang"
                                            v-model="form.endDate"
                                            :rules="inputRules"
                                            :min="statusDateConfig.min"
                                            @change="saveStatusEnd"
                                            @input="endDatePickerShow = false">
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col
                                    cols="12">
                                    <label class="v-label theme--light">
                                        {{ $vuetify.lang.t('$vuetify.messageModal.description') }}
                                    </label>
                                    <vue-editor id="editor"
                                        useCustomImageHandler
                                        :editorToolbar="customToolbar"
                                        :editorOptions="editorOption"
                                        @image-added="handleImageAdded"
                                        v-model="form.description"
                                        ></vue-editor>
                                </v-col>
                            </v-row>

                            <v-card-actions>
                                <v-spacer></v-spacer>

                                <v-btn
                                    @click="cancel()"
                                    outlined
                                    class="mr-2"
                                    width="150"
                                    color="primary">
                                    {{ $vuetify.lang.t('$vuetify.messageModal.cancel') }}
                                </v-btn>

                                <v-btn
                                    @click="submit()"
                                    width="150"
                                    color="primary">
                                    {{ $vuetify.lang.t('$vuetify.messageModal.save') }}
                                </v-btn>
                            </v-card-actions>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-form>
        </v-dialog>
    </v-row>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import Quill from 'quill'
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)
export default {
    name: 'formMessage',
    components: {
        VueEditor
    },
    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        },
        header () {
            if (this.action === 'create') {
                if (this.typeMessage === 'IND') {
                    return this.trans.messageModal.createIndividualMessage
                } else {
                    return this.trans.messageModal.createBillboardMessage
                }
            } else {
                if (this.typeMessage === 'IND') {
                    return this.trans.messageModal.updateIndividualMessage
                } else {
                    return this.trans.messageModal.updateBillboardMessage
                }
            }
        },
        errorMsg () {
            return this.trans.messageModal.msgError
        },
        congratulationTitle () {
            return this.trans.messageModal.congratulation
        },
        autocompleteRules () {
            return [
                v => this.$validator.hasValue(v, this.trans.messageModal.msgRequiredField)
            ]
        },
        inputRules () {
            return [
                v => this.$validator.hasValue(v, this.trans.messageModal.msgRequiredField),
                v => this.$validator.lengthNotExceed(v, 255, this.trans.messageModal.msgExceededField)
            ]
        },
        msgErrorUpload () {
            return {
                title: this.trans.messageModal.msgErrorUpload,
                text: this.trans.messageModal.msgErrorUploadImageFail,
                type: 'error'
            }
        },
        msgErrorUploadSize () {
            return {
                title: this.trans.messageModal.msgErrorUpload,
                text: this.trans.messageModal.msgErrorSizeUpload,
                type: 'error'
            }
        },
        msgCreateSuccess () {
            return this.trans.messageModal.msgCreateSuccess
        },
        msgUpdateSuccess () {
            return this.trans.messageModal.msgUpdateSuccess
        }
    },
    data () {
        return {
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                [
                    { align: '' },
                    { align: 'center' },
                    { align: 'right' },
                    { align: 'justify' }
                ],
                ['bold', 'italic', 'underline', 'strike'], // toggled buttons
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['link', 'image'],
                ['clean'] // remove formatting button
            ],
            editorOption: {
                modules: {
                    imageDrop: true,
                    imageResize: true
                },
                theme: 'snow'
            },
            dialog: false,
            typeText: '',
            action: '',
            // rules errors
            valid: true,
            employeeNoList: [],
            form: {
                id: '',
                topic: '',
                description: '',
                typeMessage: '',
                start_date: this.$util.getCurrentDate(),
                endDate: this.$util.getCurrentDate(),
                employeeId: '',
                branchId: localStorage.getItem('currentBranchId')
            },
            errors: [],
            startDatePickerShow: false,
            endDatePickerShow: false,
            startDateFormatted: this.$util.formatDate(this.$util.getCurrentDate()),
            endDateFormatted: this.$util.formatDate(this.$util.getCurrentDate()),
            statusDateConfig: {
                min: `${new Date().getFullYear() - 100}-01-01`
            }
        }
    },
    props: {
        mode: {
            type: String,
            default: null
        },

        updateMessageId: {
            type: Number,
            default: null
        },

        typeMessage: {
            type: String,
            default: 'ANN'
        }
    },
    methods: {
        async toBase64 (file) {
            return new Promise((resolve, reject) => { // Convert file to base64
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
            })
        },
        async handleImageAdded (file, Editor, cursorLocation, resetUploader) {
            this.$store.dispatch('setLoading', true)
            const cFile = await this.toBase64(file)
            const typeFile = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif']
            const sizeFile = 10000000 // Limit file size 10 MB
            if (typeFile.includes(file.type) && file.size <= sizeFile) {
                const response = await this.axios.post('messages/upload-image', { imageBinary: cFile, filename: file.name }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                if (response && response.data && response.data.status === 'ok') {
                    Editor.insertEmbed(cursorLocation, 'image', response.data.url)
                    resetUploader()
                } else {
                    this.$notify(this.msgErrorUpload)
                }
            } else {
                this.$notify(this.msgErrorUploadSize)
            }
            this.$store.dispatch('setLoading', false)
        },
        clearForm () {
            this.form = {
                topic: '',
                description: '',
                typeMessage: '',
                startDate: this.$util.getCurrentDate(),
                endDate: this.$util.getCurrentDate(),
                employeeId: '',
                branchId: localStorage.getItem('currentBranchId')
            }
            this.startDatePickerShow = false
            this.endDatePickerShow = false
            this.startDateFormatted = this.$util.formatDate(this.$util.getCurrentDate())
            this.endDateFormatted = this.$util.formatDate(this.$util.getCurrentDate())
            this.errors = []
        },
        async getSearchEmployeeNo () {
            const res = await this.axios.get(`employee-all?branch=${this.form.branchId}`)
            if (res && res.data && res.data.status === 'ok') {
                this.employeeNoList = res.data.data
            }
        },
        async getMessage () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.get(`message/${this.updateMessageId}`)
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                const data = res.data.data
                this.form = {
                    topic: data.topic,
                    description: data.description,
                    typeMessage: data.type_message,
                    startDate: data.start_date,
                    endDate: data.end_date,
                    branchId: data.branch
                }
                if (data.employee) {
                    this.form.employeeId = data.employee
                }
                this.startDateFormatted = this.$util.formatDate(data.start_date)
                this.endDateFormatted = this.$util.formatDate(data.end_date)
            }
        },

        async getBranch () {
            this.form.branchId = localStorage.getItem('currentBranchId')
        },

        cancel () {
            this.dialog = false
            this.clearForm()
            this.$emit('close-modal')
        },

        submit () {
            if (!this.$refs.form.validate()) {
                return false
            }

            this.form.topic = this.form.topic.trim()
            this.form.typeMessage = this.typeMessage
            if (this.mode === 'create') {
                this.createMessage()
            } else if (this.mode === 'update') {
                this.updateMessage()
            }
        },

        async createMessage () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.post('message/create', this.form)
            this.checkRespose(res)
        },

        async updateMessage () {
            this.$store.dispatch('setLoading', true)
            const url = `message/update/${this.updateMessageId}`
            const res = await this.axios.put(url, this.form)
            this.checkRespose(res)
        },

        checkRespose (res) {
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                this.$emit('success-saved')
                let msgSuccess = this.msgCreateSuccess
                if (this.mode === 'update') {
                    msgSuccess = this.msgUpdateSuccess
                }
                this.$notify({
                    title: this.congratulationTitle,
                    text: msgSuccess.replace('$Name', this.form.topic),
                    type: 'success'
                })
                this.dialog = false
                this.clearForm()
            } else if (res && res.data && res.data.status === 'error') {
                this.errors = res.data.message
                this.$store.dispatch('setLoading', false)
                this.$notify({
                    title: this.errorMsg,
                    text: this.errors,
                    type: 'error'
                })
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)

                for (const property in this.errors) {
                    this.$notify({
                        title: this.errorMsg,
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        saveStatusStart (date) {
            this.startDateFormatted = this.$util.formatDate(date)
        },

        saveStatusEnd (date) {
            this.endDateFormatted = this.$util.formatDate(date)
        }
    },

    async mounted () {
        await this.getBranch()
        // this.checkPermission()

        this.registerLang({
            messageModal: [
                'createIndividualMessage',
                'createBillboardMessage',
                'updateIndividualMessage',
                'updateBillboardMessage',
                'msgError',
                'congratulation',
                'msgRequiredField',
                'msgExceededField',
                'msgErrorUpload',
                'msgErrorUploadImageFail',
                'msgErrorSizeUpload',
                'msgCreateSuccess',
                'msgUpdateSuccess'
            ]
        })
    },

    watch: {
        async mode (newValue) {
            if (this.typeMessage === 'IND') {
                await this.getSearchEmployeeNo()
            }
            if (newValue === 'create') {
                this.action = 'create'
                this.clearForm()
            } else if (newValue === 'update') {
                await this.getMessage()
                this.action = 'update'
            }
        }
    }
}
</script>
<style>
</style>
